module.exports = __webpack_public_path__ + "img/INTERIOR-BALENO-2.3a557c21.jpg";